import React from 'react';
import { apiGetDevice, apiTrackPage } from "../api"; 
import { 
    UPDATE_HEADER_INFO, UPDATE_HEADER_INFO_FAILED, 
    GET_DEVICE_DATA, GET_DEVICE_DATA_FAILED, 
    APP_TRACK_DATA, APP_TRACK_DATA_FAILED
} from "./types";

export const getDeviceData = data => async dispatch => {
    try {
        let temp = await apiGetDevice(data);
        dispatch({
            type: GET_DEVICE_DATA,
            payload: temp
        });
    } catch (e) {
        dispatch({
            type: GET_DEVICE_DATA_FAILED,
            payload: e
        });
    }
}

export const updateHeaderInfo = data => async dispatch => {
    if (typeof data.iconOne === 'undefined') { data.iconOne = 'home'; }
    if (typeof data.iconTwo === 'undefined') { data.iconTwo = 'menu'; }
    if (typeof data.name === 'undefined') { data.name = 'AUA University'; }
    if (typeof data.color === 'undefined') { data.color = '#00567a'; } 

    let obj = {
        headerText: '',
        iconOne: '',
        iconTwo: 'menu',
        backgroundcolor: data.color
    }

    switch (data.route) {
        case "home": {
            obj = { headerText: "AUA University", iconOne: "", iconTwo: "menu", backgroundcolor: data.color };
            break;
        }

        default: {
            obj = { headerText: data.name, iconOne: data.iconOne, iconTwo: data.iconTwo, backgroundcolor: data.color };
            break;
        } 
    }

    try {
        // console.log('\nupdateHeaderInfo: ', obj);
        dispatch({
            type: UPDATE_HEADER_INFO,
            payload: obj
        });
    } catch (e) {
        // console.log('\nFailed: ', e);
        dispatch({
            type: UPDATE_HEADER_INFO_FAILED,
            payload: e
        });
    }    
};

export const trackPage = (mcid, data) => async dispatch => {
    // console.log(mcid);
    // console.log(data);
    try {
        const response = await apiTrackPage(mcid, data);
        dispatch({
            type : APP_TRACK_DATA,
            payload : response
        });
    } catch (e) {
        console.log('error: ', e);
        dispatch({
            type : APP_TRACK_DATA_FAILED,
            payload : e
        });
    }
}